import { LocalDateTime } from 'js-joda';
import clsx from 'clsx';

import { DisplayTime } from '@tock/time';
import PureBaseComponent from '@tock/shared/components/PureBaseComponent';

interface Props {
  className?: string;
  displayTimeAsShort?: boolean;
  preassignmentTime?: string;
  isOverlapping: boolean;
  isPinned?: boolean;
}

export default class ServiceTablePreassignment extends PureBaseComponent<Props> {
  render() {
    const {
      className: classNameFromProps,
      isOverlapping,
      isPinned,
      displayTimeAsShort,
      preassignmentTime,
    } = this.props;

    const className = clsx('ServiceTable-preassignment', classNameFromProps, {
      'is-pinned': isPinned,
      'is-overlapping': isOverlapping,
    });

    return (
      <div className={className} data-testid="pre-assign-time">
        {!preassignmentTime && 'Walkin'}

        {preassignmentTime && (
          <DisplayTime
            displayTimeAsShort={displayTimeAsShort}
            timeValue={LocalDateTime.parse(preassignmentTime)}
          />
        )}
      </div>
    );
  }
}
